// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lgD63","right":"styles_right__1PjC9"};